module.exports = __webpack_public_path__ + "img/activities-2.c76b4b37.jpg";